/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PositionCto } from '../../models/position-cto';

export interface GetJobAsync$Json$Params {
  positionGuid: string;
}

export function getJobAsync$Json(http: HttpClient, rootUrl: string, params: GetJobAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
  const rb = new RequestBuilder(rootUrl, getJobAsync$Json.PATH, 'get');
  if (params) {
    rb.path('positionGuid', params.positionGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PositionCto>;
    })
  );
}

getJobAsync$Json.PATH = '/job/{positionGuid}';
